// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};